/**
 * @file
 * Use this space to create your own custom helper
 * Note1: your custom helper can be accessed in 'simpli-web-sdk'
 * Note2: be sure the name you have chosen does not exist in simpli-web-sdk
 */

// @ts-ignore
import zipcelx from 'zipcelx'
// @ts-ignore
import audioAlert from '@/assets/audio/unsure.mp3'
import {mapKeys, map, forOwn, omitBy} from 'lodash'
import {
  $,
  Resource,
  ClassType,
  SchemaData,
  SchemaVal, Dictionary,
} from 'simpli-web-sdk'
import * as Helper from '@/helpers'
import Carga from '@/model/resource/Carga'
import moment from 'moment'
import xlsx from 'xlsx'
import { AppConfig } from '@/config/app.config'
import CargaCsvSimplificado from '@/model/resource/CargaCsvSimplificado'
import CargaCsvSimplesSemCheckAtendimento from '@/model/resource/CargaCsvSimplesSemCheckAtendimento'
import CargaCsvSimplesSemCheckComponente from '@/model/resource/CargaCsvSimplesSemCheckComponente'
import CargaCsvSimplesSemTipoFinalizacaoSucesso from '@/model/resource/CargaCsvSimplesSemTipoFinalizacaoSucesso'
import CargaCsvSimplesSemQtdFotoObservacaoColeta from '@/model/resource/CargaCsvSimplesSemQtdFotoObservacaoColeta'
import {Role} from '@/enums/Role'
import {MapConfig} from '@/config/map.config'

export function getIdFilial(): number {
  return Number(localStorage.getItem('idFilial')) || 0
}

export function setIdFilial(val: number) {
  return localStorage.setItem('idFilial', `${val}`)
}

export function getAllowNotification(): boolean {
  return Boolean(localStorage.getItem('allowNotification')) || false
}

export function setAllowNotification(val: boolean) {
  return localStorage.setItem('allowNotification', val ? '1' : '')
}

export function setRole(val: string) {
    return localStorage.setItem('role', val)
}

export function setUsuarioNome(val: string) {
  return localStorage.setItem('usuarioNome', val)
}

export function getUsuarioNome(): string {
  return String(localStorage.getItem('usuarioNome'))
}

export function setAdminNome(val: string) {
    return localStorage.setItem('admNome', val)
}

export function getAdminNome(): string {
    return String(localStorage.getItem('admNome'))
}

export function hasUserData(): boolean {
    return Boolean(localStorage.getItem('ud'))
}

export function isSac(): boolean {
    return String(localStorage.getItem('role')) === 'SAC'
}

export function isRastreamento(): boolean {
    return String(localStorage.getItem('role')) === 'RASTREAMENTO'
}

export function getUpdateAutomaticallyCockpit(): boolean {
  return Boolean(localStorage.getItem('updateAutomaticallyCockpit')) || false
}

export function setUpdateAutomaticallyCockpit(val: boolean) {
  return localStorage.setItem('updateAutomaticallyCockpit', val ? '1' : '')
}

export function getUpdateAutomaticallyTracking(): boolean {
  return Boolean(localStorage.getItem('updateAutomaticallyTracking')) || false
}

export function setUpdateAutomaticallyTracking(val: boolean) {
  return localStorage.setItem('updateAutomaticallyTracking', val ? '1' : '')
}

export function isImgFile(url: string) {
  return url.match(/^\S+\.jpg|jpeg|png|gif|svg$/g)
}

export function isPdfFile(url: string) {
  return url.match(/^\S+\.pdf$/g)
}

// Caso a coluna tenha DANFE ou CTE forço o campo para ser STRING, evitando que o excel formate para notação cientifica
export function forceStringOnReport(columnName: string) {
    return columnName ? columnName.toUpperCase() === 'DANFE' || columnName.toUpperCase() === 'CTE' : false
}

export async function playAlert() {
  const audio = new Audio()
  audio.src = audioAlert
  await audio.play()
}

export async function downloadCsv(filename: string, url: string, filter: any,
                                  simplified = false, typeSimpleReport = 0) {
  const params = omitBy(Helper.classToPlain(filter), (item: any) => item === null || item === '')

  const resp = await $.http.get(Helper.apiFullURL(url), {params})
  const rows = resp.data.items

  if (!rows.length) {
    return
  }

  let i = 0
  let csvStr = ''

  for (const item of rows) {
    let schema: SchemaData | null = null

    if (!simplified) {
      const carga = new Carga()
      Helper.plainToClassFromExist(carga, item)
      schema = carga.renderSchema({asText: true}) as SchemaData
    } else {

        let carga = new CargaCsvSimplificado()
        if (typeSimpleReport === 1) {
            carga = new CargaCsvSimplesSemCheckComponente()
        }

        if (typeSimpleReport === 2) {
            carga = new CargaCsvSimplesSemCheckAtendimento()
        }

        if (typeSimpleReport === 3) {
          carga = new CargaCsvSimplesSemTipoFinalizacaoSucesso()
        }
        if (typeSimpleReport === 4) {
          carga = new CargaCsvSimplesSemQtdFotoObservacaoColeta()
        }

        Helper.plainToClassFromExist(carga, item)
        schema = carga.renderSchema({asText: true}) as SchemaData
    }

    const data = mapKeys(
      schema,
      (val: SchemaVal, key: string) => $.t(`classes.Carga.columns.${key}`) as string,
    )

    // Build header
    if (i === 0) {
      let ii = 0
      forOwn(data, (value, index) => {
        const fieldName = index === null ? '' : index.toString()
        let fieldResult = fieldName
          .replace(/"/g, '""')
          .replace(/;/g, '--')

        if (fieldResult.search(/([",\n])/g) >= 0) {
          fieldResult = '"' + fieldResult + '"'
        }
        if (ii > 0) {
          csvStr += ','
          csvStr += fieldResult
        } else {
          csvStr += fieldResult
        }
        ii++
      })
      csvStr += '\n'
    }

    const row = map(data, (value) => [value])

    // Each cell
    for (let j = 0; j < row.length; j++) {
      let innerValue = row[j] === null ? '' : row[j].toString()

      if (row[j] instanceof Date) {
        innerValue = row[j].toLocaleString()
      }

      let result = innerValue
        .replace(/"/g, '""')
        .replace(/;/g, '--')

      if (result.search(/([",\n])/g) >= 0) {
        result = `"${result}"`
      }

      if (j > 0) {
        csvStr += ','
        csvStr += result
      } else {
        csvStr += result
      }
    }

    csvStr += '\n'
    i++
  }

  Helper.createCsvFile(`${filename}.csv`, csvStr)
}

export async function downloadXlsx<R extends Resource>(
  filename: string,
  url: string,
  filter: any,
  classType: ClassType<Resource>,
  className: string,
  simplified = false,
  typeSimpleReport = 0,
  ) {
  const params = omitBy(Helper.classToPlain(filter), (item: any) => item === null || item === '')

  const resp = await $.http.get(Helper.apiFullURL(url), {params})
  const rows = resp.data.items

  if (!rows.length) {
    return
  }

  const list = rows.map((item: any) => {
      let schema: SchemaData | null = null
      if (!simplified) {
          const objectInstance = new classType()
          Helper.plainToClassFromExist(objectInstance, item)
          schema = objectInstance.renderSchema({ asText: true }) as SchemaData
      } else {
          let carga = new CargaCsvSimplificado()
          // 1 é sem componente
          if (typeSimpleReport === 1) {
            carga = new CargaCsvSimplesSemCheckComponente()
          }
          // 2 é sem atendimento
          if (typeSimpleReport === 2) {
            carga = new CargaCsvSimplesSemCheckAtendimento()
          }
          // 3 é sem Tipo de finalização com sucesso
          if (typeSimpleReport === 3) {
            carga = new CargaCsvSimplesSemTipoFinalizacaoSucesso()
          }
          // sem Quantidade de fotos da coleta e Observação Coleta
          if (typeSimpleReport === 4) {
            carga = new CargaCsvSimplesSemQtdFotoObservacaoColeta()
          }

          Helper.plainToClassFromExist(carga, item)
          schema = carga.renderSchema({asText: true}) as SchemaData
      }

      return mapKeys(
      schema,
      (val: SchemaVal, key: string) => $.t(`classes.${className}.columns.${key}`) as string,
    )
  })

  const headers = Object.keys(list[0]).map((p) => ({value: p, type: 'string'}))
  const data = list
    .map(
      (item: any) => Object.keys(item)
        .map((p) => {
          // numbers with a leading 0 are strings
          const isString = isNaN(item[p]) || (item[p] !== null && item[p].length > 1 && item[p][0] === '0')
              || forceStringOnReport(p)
          return {
            value: item[p],
            type: isString  ? 'string' : 'number',
          }
        }),
    )

  zipcelx({
    filename,
    sheet: {
      data: [
        [...headers],
        ...data,
      ],
    },
  })
}

export function parseXlsx(rawData: any) {
  const data = new Uint8Array(rawData)
  const sheet = xlsx.read(data, {
    type: 'array',
    raw: true,
  })

  let parseData: any = []
  sheet.SheetNames.forEach((sheetName) => {
    parseData = parseData.concat(xlsx.utils.sheet_to_json(sheet.Sheets[sheetName]))
  })
  return parseData
}

export function parseTxt(rawData: any) {
  const lines: string[] = rawData.split('\n')
  const splitLines: string[][] = []
  const data: object[] = []

  lines.forEach((line: string, i) => {
    const isNotEmpty = /[^\s]/.test(line)

    // Shouldn't consider line if it contains any space characters, except if it's the first line (headers)
    if ((!line.includes(' ') || i === 0) && isNotEmpty) {
      const tabs = line.split('\t')
      splitLines.push(tabs)
    }
  })

  const headers = splitLines.shift() || []

  splitLines.forEach((line: string[]) => {
    const obj: Dictionary<string | number> = {}
    headers.forEach((header: string, i) => obj[header] = line[i])
    data.push(obj)
  })

  return data
}

export function parseExcelDate(days: number, time: number) {
  let minutes = Math.round(time * 60 * 24 % 60)
  let hours = Math.floor(time * 24)
  if (minutes === 60) {
    minutes = 0
    hours += 1
  }
  return moment(AppConfig.excelFirstDate)
    .add(days - 1, 'days')
    .add(hours, 'hours')
    .add(minutes, 'minutes')
    .format($.t('dateFormat.datetime'))
}

export function datetimeForCsv(date: string | null) {
  return date ? moment(date).format($.t('dateFormat.datetimeWithZone')) : ''
}

export function formatScientificNumber(value: any, maskRemover: boolean = false) {
  value = value.toString().trim()
  const regex = /(\D+)/g

  if (maskRemover) {
    value = value.replace(regex, '')
  }

  if (value.length >= 11 && !regex.test(value)) {
    return `'${value}`
  }

  return value || ''
}

async function svgFileToString(iconpath: string) {
    const req = await fetch(iconpath)
    return await req.text()
}

export async function getIconTransport(vehicleType: string, color: string) {
    if (vehicleType === 'MOTO') {
        const motoSvgIcon: string = await svgFileToString(MapConfig.motorcycleMapSvg)
        return motoSvgIcon.replace('@@@', color)
    }
    if (vehicleType === 'FIORINO' ||
        vehicleType === 'KOMBI' ||
        vehicleType === 'VAN'
    ) {
        const carSvgIcon: string = await svgFileToString(MapConfig.carMapSvg)
        return carSvgIcon.replace('@@@', color)
    } else {
        const motorcycleSvgIcon: string = await svgFileToString(MapConfig.truckMapSvg)
        return motorcycleSvgIcon.replace('@@@', color)
    }
}
